import CreateAccountOrLogin from '@/views/signup/CreateAccountOrLogin.vue';
import SignUpOrLoginVerification from '@/views/signup/Verification.vue';
import CompanyType from '@/views/signup/CompanyType.vue';
import AccountVerification from '@/views/signup/AccountVerification.vue';
import GeneralInformation from '@/views/signup/GeneralInformation.vue';
import FMSCAContacts from '@/views/signup/FMSCAContacts.vue';
import VerificationChallenge from '@/views/signup/VerificationChallenge.vue';
import DispatcherVerificationChallenge from '@/views/signup/DispatcherVerificationChallenge.vue';
import RequestAccessFMSCA from '@/views/signup/RequestAccessFMSCA.vue';
import RequestAccess from '@/views/signup/RequestAccess.vue';
import AccountSuccess from '@/views/signup/AccountSuccess.vue';
import Invitation from '@/views/signup/Invitation.vue';
import Welcome from '@/views/signup/Welcome.vue';
import CarrierDetails from '@/views/signup/CarrierDetails.vue';
import CarrierType from '@/views/signup/CarrierType.vue';
import YourDetails from '@/views/signup/YourDetails.vue';
import CompanyDetails from '@/views/signup/CompanyDetails.vue';
import VerificationFail from '@/views/signup/VerificationFail.vue';
import EmailVerificationPending from '@/views/signup/EmailVerificationPending.vue';
import IdentityVerification from '@/views/signup/IdentityVerification.vue';
import PreferredName from '@/views/signup/PreferredName.vue';
export default [
  // Sign up Flow
  {
    path: '/sign-up',
    name: 'SignUp',
    component: Welcome,
    meta: { pageTitle: 'Sign Up', doesNotRequireAuthentication: true },
  },
  {
    path: '/sign-up/carrier-details',
    name: 'CarrierDetails',
    component: CarrierDetails,
    meta: { pageTitle: 'Carrier Details', doesNotRequireAuthentication: true },
  },
  {
    path: '/sign-up/carrier-type',
    name: 'CarrierType',
    component: CarrierType,
    meta: { pageTitle: 'Carrier Type', doesNotRequireAuthentication: true },
  },
  {
    path: '/sign-up/your-details',
    name: 'YourDetails',
    component: YourDetails,
    meta: {
      pageTitle: 'Your Details',
      doesNotRequireCompany: true,
      allowBrokerUserToAccess: true,
    },
  },
  {
    path: '/sign-up/company-details',
    name: 'CompanyDetails',
    component: CompanyDetails,
    meta: {
      pageTitle: 'Company Details',
      doesNotRequireCompany: true,
      allowBrokerUserToAccess: true,
    },
  },
  //The alias company-email is used to redirect the user to the same page, once complete the Preferred Name verification. And the PATH is used, for
  //sign up and Login views. So this route handles 3 differents scenarios.
  {
    path: '/sign-up/create-account',
    alias: '/sign-up/company-email',
    name: 'CreateAccountOrLogin',
    component: CreateAccountOrLogin,
    meta: {
      pageTitle: 'Create Account Or Login',
      doesNotRequireAuthentication: true,
    },
  },
  {
    path: '/sign-up/verification',
    name: 'SignUpOrLoginVerification',
    component: SignUpOrLoginVerification,
    meta: {
      pageTitle: 'Sign Up Verification',
      doesNotRequireAuthentication: true,
    },
    // meta: { doesNotRequireCompletedUser: true, doesNotRequireCompany: true }
  },
  {
    path: '/sign-up/invitation',
    name: 'Invitation',
    component: Invitation,
    meta: { pageTitle: 'Invite', doesNotRequireAuthentication: true },
  },
  {
    path: '/sign-up/company-type',
    name: 'CompanyType',
    component: CompanyType,
    meta: {
      pageTitle: 'Company Type',
      doesNotRequireCompletedUser: true,
      doesNotRequireCompany: true,
    },
  },
  {
    path: '/sign-up/account-verification',
    name: 'AccountVerification',
    component: AccountVerification,
    meta: {
      pageTitle: 'Account Verification',
      doesNotRequireCompletedUser: true,
      doesNotRequireCompany: true,
      allowBrokerUserToAccess: true,
    },
  },
  {
    path: '/sign-up/general-information',
    name: 'GeneralInformation',
    component: GeneralInformation,
    meta: {
      pageTitle: 'General Information',
      doesNotRequireCompletedUser: true,
      doesNotRequireCompany: true,
      allowBrokerUserToAccess: true,
    },
  },
  {
    path: '/sign-up/fmsca-account-verification',
    name: 'FMSCAAccountVerification',
    component: FMSCAContacts,
    meta: {
      pageTitle: 'FMSCA Account Verification',
      doesNotRequireCompletedUser: true,
      doesNotRequireCompany: true,
      allowBrokerUserToAccess: true,
    },
  },
  {
    path: '/sign-up/verification-challenge',
    name: 'VerificationChallenge',
    component: VerificationChallenge,
    meta: {
      pageTitle: 'Additional Verification',
      doesNotRequireCompletedUser: true,
      doesNotRequireCompany: true,
      allowBrokerUserToAccess: true,
    },
  },
  {
    path: '/sign-up/dispatch-verification-challenge',
    name: 'DispatcherVerificationChallenge',
    component: DispatcherVerificationChallenge,
    meta: {
      pageTitle: 'Additional Verification',
      doesNotRequireCompletedUser: true,
      doesNotRequireCompany: true,
    },
  },
  {
    path: '/sign-up/request-access',
    name: 'RequestAccess',
    component: RequestAccess,
    meta: {
      pageTitle: 'Request Access',
      doesNotRequireCompany: true,
      allowBrokerUserToAccess: true,
    },
  },
  {
    path: '/sign-up/request-access-fmsca',
    name: 'RequestAccessFMSCA',
    component: RequestAccessFMSCA,
    meta: {
      pageTitle: 'Request Access FMSCA',
      doesNotRequireCompany: true,
      allowBrokerUserToAccess: true,
    },
  },
  {
    path: '/sign-up/account-success',
    name: 'AccountSuccess',
    component: AccountSuccess,
    meta: { pageTitle: 'Account Success' },
  },
  {
    path: '/sign-up/verification-fail',
    name: 'VerificationFail',
    component: VerificationFail,
    meta: {
      pageTitle: 'Verification Fail',
      doesNotRequireAuthentication: true,
    },
  },
  {
    path: '/sign-up/email-verification-pending',
    name: 'EmailVerificationPending',
    component: EmailVerificationPending,
    meta: {
      pageTitle: 'Email Verification Pending',
      doesNotRequireCompany: true,
    },
  },
  {
    path: '/sign-up/identity-verification',
    name: 'IdentityVerification',
    component: IdentityVerification,
    meta: {
      pageTitle: 'Identity Verification',
      doesNotRequireCompany: true,
    },
  },
  {
    path: '/sign-up/preferred-name',
    name: 'PreferredName',
    component: PreferredName,
    meta: {
      pageTitle: 'Preferred Name',
      doesNotRequireCompany: true,
    },
  },
];
